import { ArrowPathIcon } from '@heroicons/react/24/outline'

export const LoadingSpinner = () => {
  return (
    <div className="py-1">
      <div className="flex justify-center p-4 m-4 rounded-md">
        <ArrowPathIcon className="w-8 h-8 animate-spin text-gray-300" />
      </div>
    </div>
  )
}
